import { render, staticRenderFns } from "./PhoneInputGroup.vue?vue&type=template&id=5f46995d&scoped=true"
import script from "./PhoneInputGroup.vue?vue&type=script&lang=ts"
export * from "./PhoneInputGroup.vue?vue&type=script&lang=ts"
import style0 from "./PhoneInputGroup.vue?vue&type=style&index=0&id=5f46995d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f46995d",
  null
  
)

export default component.exports